export function truncate(text, words) {
    var numberOfWords = Number(words);
    var stringWords = text.split(" ").length;
    if (stringWords >= numberOfWords) {
        var truncatedString = text
            .split(/\s+/)
            .slice(0, numberOfWords)
            .join(" ");
        return "" + truncatedString + String.fromCharCode(8230);
    }
    return text;
}



//////////////////
// WEBPACK FOOTER
// ./app/modules/blog/utils/truncate.tsx
// module id = 5Tmr
// module chunks = 3